const portfolioData = {
  //for Header.js
   name: "Rachel Spencer",
   headerLogo: "https://s24193.pcdn.co/wp-content/uploads/2016/07/entity-women-that-did-ada-lovelace-1320x720.jpg",
   //for Intro.js
   introPara: "A Frontend focused Web Developer building responsive applications, with a passion for designing accessible and intuitive user interfaces that deliver seamless user experiences.",
   linkedin:"https://www.linkedin.com/in/rachel-spencer-87a539246/",
   github: "",
   twitter:"",                                                    
   youtube:"",
   //for AboutMe.js
   aboutPara: "Here you will find more information about me and my current skills in terms of designing and programming.",
   paraOne: "My interest in Front End Development started in 2022. Free courses on Codecademy led to my enrollment in Devmountain's part time Web Development bootcamp (Aug 2022 - May 2023). It's fair to say I caught the bug, no pun intended.",
   paraTwo: "I am passionate about both UI/UX design and web development. I love the process of transforming wireframes into vibrant, user-friendly interfaces using Figma, CSS, Tailwind, JavaScript and React.",
   paraThree: "Since my graduation I have continued to build on my skills by designing and developing applications in my spare time.",
   //for Contact.js
   contactPara: "Feel free to contact me by submitting the form below and I will get back to you as soon as possible.",
};


export default portfolioData; 
